import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import GetSeodata from '../Components/GetSeodata'

function PrivacyPolicy() {
  return (
    <>
        <Navbar/>
        <GetSeodata PageName={'policy'} />
        <div className='about-div'>
        <h1>Privacy Policy</h1>
        <p><i>Home - Privacy Policy</i></p>

        </div>
        <div className='TermsNCondiation'>
        <h2>1. Information We Collect</h2>
    <p>To provide seamless travel solutions, we collect the following types of information:</p>
    <h3>a. Personal Information</h3>
    <ul>
        <li>Full name, email address, phone number, and mailing address.</li>
        <li>Payment details, including credit/debit card information.</li>
        <li>Passport and visa details for travel and booking purposes.</li>
    </ul>
    <h3>b. Non-Personal Information</h3>
    <ul>
        <li>Browser type, IP address, device information, and operating system.</li>
        <li>Cookies and analytics data for website performance and optimization.</li>
    </ul>
    <h3>c. Voluntary Information</h3>
    <ul>
        <li>Travel preferences, feedback, and queries submitted through forms.</li>
        <li>Participation in surveys, promotions, and contests.</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <ul>
        <li>Processing Bookings: Confirming reservations, issuing tickets, and providing travel updates.</li>
        <li>Customer Support: Responding to inquiries and resolving issues efficiently.</li>
        <li>Marketing & Promotions: Sending newsletters, exclusive offers, and travel updates (with your consent).</li>
        <li>Website Optimization: Enhancing user experience and analyzing website performance.</li>
        <li>Legal Compliance: Ensuring compliance with applicable laws and protecting company interests.</li>
    </ul>

    <h2>3. Sharing Your Information</h2>
    <p>We respect your privacy and do not sell or rent your personal data. However, data may be shared in the following circumstances:</p>
    <ul>
        <li>Service Providers: Shared with hotels, airlines, and transportation providers to fulfill your bookings.</li>
        <li>Payment Gateways: For secure payment processing.</li>
        <li>Legal Authorities: When legally required or to safeguard our rights.</li>
        <li>Business Partners: With your explicit consent for co-branded promotions or offers.</li>
    </ul>

    <h2>4. Data Security</h2>
    <p>We implement robust security protocols to protect your information:</p>
    <ul>
        <li>Data Encryption: Sensitive data is encrypted during transmission to prevent unauthorized access.</li>
        <li>Access Control: Only authorized personnel have access to personal information.</li>
        <li>System Audits: Regular security reviews and updates to identify and address vulnerabilities.</li>
    </ul>

    <h2>5. Cookies and Tracking Technologies</h2>
    <p>We use cookies and tracking technologies to:</p>
    <ul>
        <li>Enhance website navigation and save user preferences.</li>
        <li>Analyze website traffic using tools like Google Analytics.</li>
        <li>Provide personalized advertisements based on browsing behavior.</li>
    </ul>
    <p>You can manage or disable cookies via browser settings; however, this may limit some website functionality.</p>

    <h2>6. Your Rights</h2>
    <p>You have the following rights regarding your personal data:</p>
    <ul>
        <li>Access and Rectification: Request access to your data and correct inaccuracies.</li>
        <li>Data Portability: Obtain a copy of your information in a structured format.</li>
        <li>Withdraw Consent: Opt-out of marketing communications at any time.</li>
        <li>Right to Deletion: Request removal of your data, subject to legal or regulatory obligations.</li>
        <li>Object to Processing: Restrict or object to specific uses of your information.</li>
    </ul>
    <p>For assistance, contact us at <a href="mailto:b2b@expleradmc.com">b2b@expleradmc.com</a>.</p>

    <h2>7. Data Retention</h2>
    <p>We retain personal data only as long as necessary to:</p>
    <ul>
        <li>Fulfill travel-related services and manage bookings.</li>
        <li>Meet legal, tax, and accounting requirements.</li>
        <li>Improve our offerings based on historical data and interactions.</li>
    </ul>

    <h2>8. Third-Party Links</h2>
    <p>Our website may include links to external websites. While we aim to associate with trusted third parties, we are not responsible for their privacy practices. Please review their privacy policies before sharing any personal information.</p>

    <h2>9. International Data Transfers</h2>
    <p>As a globally active travel service provider, your data may be transferred and processed outside your home country, including Thailand, in compliance with local and international privacy laws.</p>

    <h2>10. Updates to Privacy Policy</h2>
    <p>We may periodically update this Privacy Policy to reflect changes in our practices, services, or legal requirements. Updates will be clearly posted on this page with the effective date.</p>
        </div>
        <Footer/>
    </>
  )
}

export default PrivacyPolicy